import { CommonModule, isPlatformBrowser } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LoginFormComponent, LoginSuccessPayload } from '../login-form/login-form.component';
import { SuspendedAccountModalComponent } from '@shared/suspended-account-modal/suspended-account-modal.component';
import { showAuthErrorSwal } from '@shared/utils/auth-swal.util';
import { buildCrossLoginUrl } from '@shared/utils/cross-login.util';
import { DomainService } from '@core/services/domain.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, TranslateModule, LoginFormComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  isQP23 = ['qp23'].includes(environment.projectCode.toLowerCase());

  private readonly isBrowser: boolean;

  constructor(
    private domainService: DomainService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private dialog: MatDialog,
    private translateService: TranslateService,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    /* SEO is intentionally not set on auth pages (no indexing value). */
  }

  onLoginSuccess(payload: LoginSuccessPayload): void {
    if (!this.isBrowser) return;
    const { access_token, plaintext_token } = payload.auth ?? ({} as any);
    const crossLoginUrl = buildCrossLoginUrl(this.domainService.getOldDomainUrl(), access_token, plaintext_token);
    if (crossLoginUrl) {
      window.location.href = crossLoginUrl;
    } else {
      this.router.navigate(['/home']);
    }
  }

  onLoginError(err: HttpErrorResponse): void {
    if (!this.isBrowser) return;
    showAuthErrorSwal(err, this.translateService);
  }

  /* AIO-76562: open the OTP recovery flow for a temporarily-suspended account. */
  onAccountSuspended(data: { mobile: string; username: string }): void {
    if (!this.isBrowser) return;
    this.dialog.open(SuspendedAccountModalComponent, {
      data,
      panelClass: 'auth-modal-pane',
      autoFocus: false,
      disableClose: true,
    });
  }

  onForgotCredential(type: 'password' | 'username'): void {
    this.router.navigate(['/forgot-credential'], { queryParams: { type } });
  }

  onSignup(): void {
    this.router.navigate(['/signup']);
  }
}
